import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 8.25a1.5 1.5 0 0 0-1.5-1.5H10.5l-1.8-2.4a1.5 1.5 0 0 0-1.2-.6H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5Z"
    }, null, -1)
  ]));
}
const interfaceContentFolder = { render };
export {
  interfaceContentFolder as default,
  render
};
//# sourceMappingURL=interface-content-folder.svg.js.map
